import { useContext, useEffect, useState } from 'react';
import Card from './components/card/Card';
import CardKlijenti from './components/card/CardKlijenti';
import styles from './index.module.css';
import MasineForm from './components/MasineForm/MasineForm';
import useHttp from '../../../hooks/use-http';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import DetailView from './components/DatailView/DetailView';
import { useTranslation } from 'react-i18next';
import Spinner from '../../UI/Modal/Spinner';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import Delovi from './components/Delovi';
import SearchForm from './components/SearchForm/SearchForm';
import { TabContext } from '../../../Context/TabContext';
import Dnevnik from './components/Dnevnik/Dnevnik';
import Testiranje from './components/Testiranje';
import Ciklusi from './components/Ciklusi';

const Masine = ({
  novaMasina,
  handleNovaMasina,
  handleDisableBtnNovaMasina,
}) => {
  const INITIAL_VALUES = {
    sifra: '',
  };
  const { t, i18n } = useTranslation();

  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localData = dataLocal?.data ? dataLocal?.data : null;
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterValues, setFilterValues] = useState(INITIAL_VALUES);
  const { getData: getMasine, isLoading: isLoadingMasine } = useHttp('');
  const [openDetalView, setOpenDetalView] = useState(false);
  const [machineDetail, setMachineDetail] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openPartsDialog, setOpenPartsDialog] = useState(false);
  const [openDnevnik, setOpenDnevnik] = useState(false);
  const [openTestiranje, setOpenTestiranje] = useState(false);
  const [openCiklusi, setOpenCiklusi] = useState(false);
  const [masineData, setMasineData] = useState({ source: [], filtered: [] });
  const [machineId, setMachineId] = useState(0);
  const [idProjekta, setIdProjekta] = useState(0);
  const [idMasineTest, setIdMasineTest] = useState(0);
  const [filterMasine, setFilterMasine] = useState([]);
  const [responseTipMasina, setResponseTipMasina] = useState([]);
  const localFormValues = dataLocal?.filterValues
    ? dataLocal?.filterValues
    : {};
  const localMasineData = dataLocal?.masineData ? dataLocal?.masineData : {};
  const localSelectedFilters = dataLocal?.selectedFilters
    ? dataLocal?.selectedFilters
    : [];

  useEffect(() => {
    const tab = {
      type: 68,
      title: 'Oprema',
      icon: 'fas fa-cogs',
      filterValues: filterValues,
      masineData: masineData,
      selectedFilters: selectedFilters,
    };
    onTabChange(tab);
  }, [filterValues, masineData, selectedFilters]);
  useEffect(() => {
    if (Object.keys(localFormValues).length > 0) {
      setFilterValues({
        ...localFormValues,
      });
    }
    if (Object.keys(localMasineData).length > 0) {
      setMasineData({
        ...localMasineData,
      });
    }
    if (localSelectedFilters.length > 0) {
      setSelectedFilters(localSelectedFilters);
    }
  }, []);

  useEffect(() => {
    if (novaMasina) {
      setOpenDialog(true);
      setMachineId(0);
    }
    handleNovaMasina(false);
  }, [novaMasina]);
  useEffect(() => {
    if (localStorage.idFirme !== '1') {
      handleDisableBtnNovaMasina({ id: activeComponent, disabled: true });
    }
  }, []);
  const vratiMasine = async () => {
    const config = {
      method: 'POST',
      url: 'Masine/vrati_masine',
      data: { idKorProm: +localStorage.idKorisnika, metadata: i18n.language },
    };
    const response = await getMasine(config);

    if (response.length > 0) {
      // if (Object.keys(localMasineData).length === 0) {
      console.log('first');
      setMasineData({ source: response, filtered: response });
      // }
      const tipovi = [];
      const robot = response.some((item) => item.tipMasine === t('Robot'));
      if (robot) {
        tipovi.push(t('Robot'));
      }
      const alat = response.some((item) => item.tipMasine === t('Alat'));
      if (alat) {
        tipovi.push(t('Alat'));
      }
      console.log('tipovi', tipovi);
      setResponseTipMasina(tipovi);
    }
  };

  const vratiMasineZaKlijenta = async (id) => {
    const config = {
      url: 'Masine/vrati_masine_za_id_kupca',
      method: 'POST',
      data: {
        id: id,
        idKorProm: +localStorage.idKorisnika,
        metadata: i18n.language,
      },
    };
    const response = await getMasine(config);

    if (response.length > 0) {
      setMasineData({ source: response, filtered: response });
      const tipovi = [];
      const robot = response.some((item) => item.tipMasine === t('Robot'));
      if (robot) {
        tipovi.push(t('Robot'));
      }
      const alat = response.some((item) => item.tipMasine === t('Robot'));
      if (alat) {
        tipovi.push(t('Alat'));
      }
      console.log('tipovi', tipovi);
      setResponseTipMasina(tipovi);
    }
  };

  const vratiFilterZaMasine = async (id) => {
    const config = {
      url: 'Masine/tip_masina_provera_nadleznosti',
      method: 'POST',
      data: { idKorProm: +localStorage.idKorisnika, metadata: i18n.language },
    };
    const response = await getMasine(config);

    if (response.length > 0) {
      setFilterMasine(response);
    } else {
      setFilterMasine([]);
    }
  };
  const vratiMasinePoUslovu = () => {
    console.log(localData);
    if (localData?.idKlijenta) {
      vratiMasineZaKlijenta(localData?.idKlijenta);
    } else if (+localStorage.idFirme === 1) {
      vratiMasine();
    } else {
      vratiMasineZaKlijenta(+localStorage.idFirme);
    }
  };
  useEffect(() => {
    vratiFilterZaMasine();
  }, [i18n.language]);

  useEffect(() => {
    vratiMasinePoUslovu();
  }, []);

  const handleOpenDetalView = (item) => {
    console.log(item);
    setOpenDetalView(true);
    setMachineDetail(item);
  };
  const handleIzmeni = (e, machine) => {
    e.stopPropagation();
    setOpenDialog(true);
    setMachineId(machine.id);
  };
  const handleOpenDelete = (e, machine) => {
    e.stopPropagation();
    setOpenDeleteDialog(true);
    setMachineId(machine.id);
  };
  const handleDodajDelove = (e, machine) => {
    e.stopPropagation();
    setOpenPartsDialog(true);
    setMachineId(machine.id);
  };
  const handleOpenDnevnik = (e, machine) => {
    e.stopPropagation();
    setOpenDnevnik(true);
    setMachineId(machine.id);
  };

  const handleOpenTestiranje = (e, machine) => {
    e.stopPropagation();
    setOpenTestiranje(true);
    setIdProjekta(machine.idProjekta);
    setIdMasineTest(machine.id);
  };
  const handleOpenCiklusi = (e, machine) => {
    e.stopPropagation();
    setOpenCiklusi(true);
    setMachineId(machine.id);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: 'Masine/brisanje_masine',
      data: { id: machineId },
    };
    const id = await getMasine(config);
    if (machineId === id) {
      setOpenDeleteDialog(false);
      setMachineId(0);
      toast.success(t('machineDeletedSuccessfully'));
      vratiMasinePoUslovu();
      return;
    }
    toast.error(handleErrorMessage(id));
  };
  return (
    <>
      {isLoadingMasine && <Spinner />}
      <div>
        <div className={styles.searchContainer}>
          <SearchForm
            setMasineData={setMasineData}
            masineData={masineData}
            filterMasine={filterMasine}
            setFilterMasine={setFilterMasine}
            responseTipMasina={responseTipMasina}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </div>
        <div className={styles.cardContainer}>
          {localStorage.idFirme === '1'
            ? masineData.filtered.map((machine) => (
                <Card
                  key={machine.id}
                  machine={machine}
                  handleOpenDetalView={() =>
                    handleOpenDetalView({ ...machine, tipPregled: 'detalji' })
                  }
                  handleOpenDocumentView={() =>
                    handleOpenDetalView({ ...machine, tipPregled: 'dokumenti' })
                  }
                  handleIzmeni={handleIzmeni}
                  handleDelete={handleOpenDelete}
                  handleDodajDelove={handleDodajDelove}
                  handleOpenDnevnik={handleOpenDnevnik}
                  handleOpenTestiranje={handleOpenTestiranje}
                  handleOpenCiklusi={handleOpenCiklusi}
                />
              ))
            : masineData.filtered.map((machine) => (
                <CardKlijenti
                  key={machine.id}
                  machine={machine}
                  handleOpenDetalView={() =>
                    handleOpenDetalView({ ...machine, tipPregled: 'detalji' })
                  }
                  handleOpenDocumentView={() =>
                    handleOpenDetalView({ ...machine, tipPregled: 'dokumenti' })
                  }
                />
              ))}
        </div>
      </div>
      <MuiDialog
        maxWidth="xl"
        open={openDetalView}
        title={t('detalView')}
        content={
          <DetailView
            machineDetail={machineDetail}
            setMachineDetail={setMachineDetail}
          />
        }
        handleClose={() => setOpenDetalView(false)}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openPartsDialog}
        title={t('parts')}
        content={<Delovi machineId={machineId} />}
        handleClose={() => setOpenPartsDialog(false)}
        deniedText="ZATVORI"
      />
      <MasineForm
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        vratiMasine={vratiMasinePoUslovu}
        machineId={machineId}
        idKlijenta={localData?.idKlijenta}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="CLOSE"
      />
      <MuiDialog
        maxWidth="xl"
        open={openDnevnik}
        title={t('dnevnik')}
        content={<Dnevnik idMasine={machineId} />}
        handleClose={() => setOpenDnevnik(false)}
        deniedText="CLOSE"
      />{' '}
      <MuiDialog
        maxWidth="xl"
        open={openTestiranje}
        title="Testiranje"
        content={
          <Testiranje idMasine={idProjekta} idMasineTest={idMasineTest} />
        }
        handleClose={() => setOpenTestiranje(false)}
        deniedText="CLOSE"
      />{' '}
      <MuiDialog
        maxWidth="xl"
        open={openCiklusi}
        title={t('cycles')}
        content={
          <div>
            <Ciklusi idMasine={machineId} />
          </div>
        }
        handleClose={() => setOpenCiklusi(false)}
        deniedText="CLOSE"
      />
    </>
  );
};

export default Masine;
